<template>
    <div class="top-nav">
    </div>
</template>
<script setup>

</script>
<style lang="scss">
@import '../assets/css/topnav.scss';
</style>